import { render, staticRenderFns } from "./ServicosRecolhimentos.vue?vue&type=template&id=be1f2a60&scoped=true&"
import script from "./ServicosRecolhimentos.vue?vue&type=script&lang=js&"
export * from "./ServicosRecolhimentos.vue?vue&type=script&lang=js&"
import style0 from "./ServicosRecolhimentos.vue?vue&type=style&index=0&id=be1f2a60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f2a60",
  null
  
)

export default component.exports